import { render, staticRenderFns } from "./LecturesRegionEntityDetails.vue?vue&type=template&id=15e65056&scoped=true"
import script from "./LecturesRegionEntityDetails.vue?vue&type=script&lang=js"
export * from "./LecturesRegionEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LecturesRegionEntityDetails.vue?vue&type=style&index=0&id=15e65056&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e65056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e65056')) {
      api.createRecord('15e65056', component.options)
    } else {
      api.reload('15e65056', component.options)
    }
    module.hot.accept("./LecturesRegionEntityDetails.vue?vue&type=template&id=15e65056&scoped=true", function () {
      api.rerender('15e65056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LecturesRegionEntityDetails.vue"
export default component.exports